import { DialogActions, DialogContent, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { RegularButton } from "../Button";

import {
  addScheduleType,
  deleteScheduleType,
  setScheduleType,
} from "../../api/schedule_types";

export default function ScheduleTypeEdit(props) {
  const { isNew, obj, onClose, open } = props;

  const [isDelete, setDelete] = React.useState(false);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: (event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());
          const name = formJson.name;
          console.log(name);
          if (isNew) {
            console.log("新規");
            addScheduleType(formJson).then(handleClose);
          } else if (isDelete) {
            formJson.id = obj.id;
            console.log(`削除${JSON.stringify(formJson)}`);
            deleteScheduleType(formJson).then(handleClose);
          } else {
            formJson.id = obj.id;
            console.log(`変更:${JSON.stringify(formJson)}`);
            setScheduleType(formJson).then(handleClose);
          }
        },
      }}
    >
      <DialogTitle>スケジュール分類</DialogTitle>
      <DialogContent sx={{ width: "420px" }}>
        {/*<DialogContentText>*/}
        {/*    スケジュール分類を登録します。*/}
        {/*</DialogContentText>*/}
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="name"
          label="名称"
          type="text"
          fullWidth
          variant="standard"
          defaultValue={obj ? obj.name : ""}
        />
        <TextField
          autoFocus
          required
          margin="dense"
          id="description"
          name="description"
          label="説明"
          type="text"
          fullWidth
          variant="standard"
          defaultValue={obj ? obj.description : ""}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>キャンセル</Button>
        <RegularButton
          type="submit"
          variant="contained"
          color="error"
          size="medium"
          sx={{
            display: isNew ? "none" : "block",
          }}
          onClick={() => setDelete(true)}
        >
          削除
        </RegularButton>
        <RegularButton
          type="submit"
          variant="contained"
          color="primary"
          size="medium"
          onClick={() => setDelete(false)}
        >
          登録
        </RegularButton>
      </DialogActions>
    </Dialog>
  );
}
